import React from 'react';

import styles from './styles.module.scss';

import cn from 'classnames';

const HeaderTitle = ({
  centerText = false,
  rightText = false,
  white = true,
  width,
  title = '',
  noBorder = false,
  style,
  children,
  ...props
}) => (
  <div
    className={cn(
      styles.table_header_title,
      centerText && styles.center_text,
      rightText && styles.right_text,
      white && styles.table_header_white,
      noBorder && styles.table_header_no_border,
      props.styles,
    )}
    style={{ ...style, width, minWidth: width}}
    {...props}
  >
    {children}
    {title}
  </div>
);

export default HeaderTitle;
